import { render, staticRenderFns } from "./TipBox.vue?vue&type=template&id=a47e11fe"
import script from "./TipBox.vue?vue&type=script&lang=js"
export * from "./TipBox.vue?vue&type=script&lang=js"
import style0 from "./TipBox.vue?vue&type=style&index=0&id=a47e11fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports